export default __webpack_public_path__ + "static/media/card-2.2a09f48a.jpeg";